import { motion } from "framer-motion";
import { BadgeCheck } from "lucide-react";
import { FadeUp, Eyebrow, SectionShell, EASE } from "./Reveal";
import { IMAGES, COMPANY } from "../constants/site";

export default function Founder() {
  return (
    <SectionShell id="founder" className="py-24 sm:py-32">
      <div className="grid lg:grid-cols-12 gap-14 items-center">
        <FadeUp className="lg:col-span-5">
          <div className="relative max-w-md mx-auto lg:mx-0">
            <div className="absolute -inset-4 rounded-[2.5rem] bg-gradient-to-br from-bluedark/20 via-transparent to-torange/25 blur-2xl" />
            <div className="relative overflow-hidden rounded-[2rem] border border-line shadow-lift bg-white">
              <motion.img
                src={IMAGES.founder}
                alt={`${COMPANY.founder}, Founder of TaccTax Solution Pvt. Ltd.`}
                data-testid="founder-photo"
                initial={{ scale: 1.12 }}
                whileInView={{ scale: 1 }}
                viewport={{ once: true, amount: 0.3 }}
                transition={{ duration: 1.6, ease: EASE }}
                className="w-full h-[480px] sm:h-[540px] object-cover"
              />
              <div className="absolute bottom-0 inset-x-0 bg-gradient-to-t from-ink/90 via-ink/40 to-transparent p-7">
                <p data-testid="founder-name" className="font-display text-2xl font-bold text-white">{COMPANY.founder}</p>
                <p className="mt-1 font-mono text-[11px] uppercase tracking-[0.25em] text-orange-300">Founder — Chartered Accountant</p>
              </div>
            </div>
          </div>
        </FadeUp>

        <div className="lg:col-span-7">
          <FadeUp>
            <Eyebrow>Leadership</Eyebrow>
            <h2 className="mt-5 font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight leading-[1.08] text-ink">
              Chartered Accountant expertise, <span className="text-gradient">on every file.</span>
            </h2>
          </FadeUp>
          <FadeUp delay={0.12}>
            <p className="mt-7 text-slate-600 leading-relaxed text-base sm:text-lg max-w-2xl">
              TaccTax is led by {COMPANY.founder}, a Chartered Accountant with
              over three years of dedicated, hands-on experience in US
              bookkeeping and US taxation — spanning individual and business
              returns for CPA firms across the United States.
            </p>
            <p className="mt-5 text-slate-500 leading-relaxed max-w-2xl">
              That oversight isn't a slide deck claim: every deliverable passes
              through CA-level review before it reaches your inbox, and the
              team's training is anchored in US GAAP, IRS requirements and the
              day-to-day reality of American practice deadlines.
            </p>
          </FadeUp>
          <FadeUp delay={0.22} className="mt-9 flex flex-col sm:flex-row gap-4">
            {["3+ years in US bookkeeping & taxation", "Individual + business return depth", "90+ US clients under CA supervision"].map((c) => (
              <div key={c} className="flex items-center gap-2.5 rounded-2xl border border-line bg-card shadow-soft px-5 py-4">
                <BadgeCheck size={18} className="text-bluze shrink-0" />
                <span className="text-sm font-semibold text-ink">{c}</span>
              </div>
            ))}
          </FadeUp>
        </div>
      </div>
    </SectionShell>
  );
}
